import { RefreshCw, Power } from "lucide-react";
import { Monitor } from "lucide-react";
import StatusBadge from "../StatusBadge";
import { ActionsDropdown } from "@/components/ui/actions-dropdown";

interface DeviceCardHeaderProps {
  name: string;
  status: string;
  onCheckIn: () => void;
  onUnenroll: () => void;
}

const DeviceCardHeader = ({ name, status, onCheckIn, onUnenroll }: DeviceCardHeaderProps) => {
  return (
    <div className="flex justify-between items-start mb-4">
      <div className="flex items-center">
        <Monitor className="h-5 w-5 text-primary mr-2" />
        <h3 className="text-lg font-semibold">{name}</h3>
      </div>
      <div className="flex items-center gap-2">
        <StatusBadge status={status} />
        <ActionsDropdown
          actions={[
            { label: "Check In", icon: RefreshCw, onClick: onCheckIn },
            { label: "Unenroll", icon: Power, onClick: onUnenroll, destructive: true },
          ]}
        />
      </div>
    </div>
  );
};

export default DeviceCardHeader;
